import { CommonModule } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { RoleService } from '../../../Model/Role/role.service';
import { RoleFormComponent } from '../role-form/role-form.component';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-role',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule],
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss'
})
export class RoleComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective
  RoleData = [];
  Role : any[] = [];
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  private modalService = inject(NgbModal);
  dtoptions: DataTables.Settings = {};
  constructor(
    private role: RoleService,
    protected common: CommonService,
    private tooltip : TooltipService,
    private toast : ToastService,
    private download : DownloadSampleService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  filter = {
    SelectType: 'S',
    WebESSRoleMasterId: 0
  }
  ngOnInit(): void {
    this.GetRole();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  GetRole() {
    this.isDisabled = true;
    this.role.GetRole(this.filter).subscribe({
      next: (response) => {
        this.RoleData = Object.values(response.Table);
        this.isDisabled = false;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // Destroy the table first
          dtInstance.destroy();
          // Call the dtTrigger to rerender again
          this.dtTrigger.next(null);
        });
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  add(id: number) {
    if ((this.common.PageRight.IsAdd && id == 0) || (this.common.PageRight.IsEdit && id > 0)) {
      const modalRef = this.modalService.open(RoleFormComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.id = id;
  
      modalRef.result.then((result: any) => {
        if (result) {
          this.GetRole();
        }
  
      }).catch(() => {
        // Modal dismissed
      });
    }else{
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }
  
  exportToExcel() {
    this.isDisabled =  true
    const data = { 
      SelectType: 'RoleMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.Role = data;
        if(this.Role.length > 0){
          this.download.exportToExcel(this.Role, "Role_data");
          this.isDisabled =  false
        }
       else{
        this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
        this.isDisabled =  false
       }
      });
  }
}
